export enum RouteNames {
	MARKETPLACE_APP_LIST_PAGE = 'marketplace-app-list-page',
	MARKETPLACE_APP_DETAILS_PAGE = 'marketplace-app-details',
	MASTER_ORG_LANDING = 'master-org-landing-page',
	ORG_DETAILS_PAGE = 'org-details-page',
	ORG_PROFILE_PAGE = 'org-profile-page',
	ADMIN_PAGE = 'admin-page',
	AUTH_POLICY_PAGE = 'authentication-policies-page',
	API_TOKENS_PAGE = 'api-tokens-page',
	DOMAIN_CLAIM_DETAILS_PAGE = 'domain-claim-details-page',
	DOMAIN_CLAIM = 'domain-claim-page',
	USER_PROVISIONING_VORTEX = 'user-provisioning-page-vortex',
	CLAIM_PAGE = 'claim-page',
	MEMBER_PAGE = 'member-page',
	MEMBER_DETAIL_PAGE = 'member-detail-page',
	AUDIT_LOG_PAGE = 'audit-log-page',
	AUDIT_LOG_PAGE_SEARCH = 'audit-log-page-search',
	AUDIT_LOG_ASYNC_QUERY_RESULTS_PAGE = 'audit-log-async-query-results-page',
	AUDIT_LOG_EXPORT_DOWNLOAD = 'audit-log-export-download-page',
	AUDIT_LOG_ACTIVITIES_PAGE = 'audit-logs-activity-settings-page',
	SITE_AUDIT_LOG_PAGE = 'site-audit-log-page',
	SITE_AUDIT_LOG_SEARCH_PAGE = 'site-audit-log-search-page',
	SITE_AUDIT_LOG_ASYNC_QUERY_RESULTS_PAGE = 'site-audit-log-async-query-results-page',
	EXPORT_DOWNLOAD = 'export-download-page',
	SITE_APP_EXPORT_DOWNLOAD = 'site-app-export-download-page',
	UNIT_ADMIN_EXPORT_DOWNLOAD = 'unit-admin-export-download-page',
	SERVICE_ACCOUNTS_PAGE = 'service-accounts-page',
	ACTORS_PAGE = 'actors-page',
	ACTOR_DETAILS_PAGE = 'actor-details-page',
	ORG_SITES_PREVIEW_PAGE = 'org-sites-preview-page',
	SERVICE_ACCOUNT_DETAILS_PAGE = 'service-account-details-page',
	USERS_PAGE = 'unified-users-page',
	GROUPS_PAGE = 'groups-page',
	UNIFIED_USER_PROFILE_PAGE = 'unified-user-profile-page',
	UNIFIED_GROUPS_PAGE = 'unified-groups-page',
	UNIFIED_GROUP_DETAILS_PAGE = 'unified-group-details-page',
	UNIFIED_SITE_GROUPS_PAGE = 'unified-site-groups-page',
	UNIFIED_SITE_GROUP_DETAILS_PAGE = 'unified-site-group-details-page',
	UNIFIED_SITE_USERS_PAGE = 'unified-site-users-page',
	UNIFIED_SITE_USER_PROFILE_PAGE = 'unified-site-user-profile-page',
	UNIT_LIST_PAGE = 'unit-list-page',
	UNIT_PROFILE_PAGE = 'unit-profile-page',
	UNIT_LAUNCH_PAGE = 'unit-launch-page',
	UNIT_SPLASH_PAGE = 'unit-splash-page',
	UNIT_PROVISIONING_RULES_PAGE = 'unit-provisioning-rules-page',
	FOOTPRINT_PAGE = 'footprint-page',
	USER_EXPORT_DOWNLOAD_PAGE = 'user-export-download-page',
	DIRECTORY_EXPORT_DOWNLOAD_PAGE = 'directory-export-download-page',
	COMPLIANCE_PAGE = 'compliance-page',
	COMPLIANCE_BAA_FEATURE_GATE_PAGE = 'compliance-baa-feature-gate-page',
	COMPLIANCE_DATA_RETENTION_PAGE = 'compliance-data-retention-page',
	DATA_RETENTION_PAGE = 'data-retention-page',
	GOVERNANCE_MANAGER_V2_PAGE = 'governance-manager-v2-page',
	ROVO_PAGE = 'rovo-page',
	CONNECTOR_DETAIL_PAGE = 'connector-detail-page',
	MIGRATION_DATA_MANAGEMENT_PAGE = 'migration-data-management-page',
	SAML_PAGE = 'saml-page',
	TEAMS_DIRECTORY_PAGE = 'teams-directory-page',
	TEAMS_PROFILE_PAGE = 'teams-profile-page',
	DATA_CLASSIFICATION_DETAILS_PAGE = 'data-classification-details-page',
	DATA_CLASSIFICATION_SETTINGS_PAGE = 'data-classification-settings-page',
	DATA_CLASSIFICATION_PAGE = 'data-classification-page',
	DATA_SECURITY_POLICIES_DETAILS = 'data-security-policies-details-page',
	DATA_SECURITY_POLICIES = 'data-security-policies-page',
	DATA_SECURITY_POLICY = 'data-security-policy',
	DETECTION_LIBRARY_PAGE = 'detection-library-page',
	FINDINGS_PAGE = 'findings-page',
	VIOLATIONS_LIST_PAGE = 'violations-list-page',
	VIOLATIONS_DETAILS_PAGE = 'violations-details-page',
	DATA_LOSS_PREVENTION_APP_ACCESS_CONTROL_PAGE = 'data-loss-prevention-app-access-control-page',
	DATA_LOSS_PREVENTION_SIMPLE_CONTROL_PAGE = 'data-loss-prevention-simple-control-page',
	USER_PROVISIONING_PAGE = 'user-provisioning-page',
	OSYNC_PAGE = 'osync-page',
	GSUITE_PAGE = 'g-suite-page',
	PRODUCTS_LIST = 'products-list-page',
	PRODUCTS_OVERVIEW = 'products-overview-page',
	USER_REQUESTS_PAGE = 'user-requests-page',
	LINK_ON_PREM_PRODUCTS_DASHBOARD = 'link-on-prem-products-dashboard-page',
	DATA_TRANSFER_PAGE = 'data-transfer-page',
	DATA_EXPORT_PAGE = 'data-export-page',
	DATA_EXPORT_CREATE_POLICY_PAGE = 'data-export-create-policy-page',
	DATA_EXPORT_EDIT_POLICY_PAGE = 'data-export-edit-policy-page',
	DATA_EXPORT_POLICY_DETAILS_PAGE = 'data-export-policy-details-page',
	REMEDIATIONS_PAGE = 'remediations-page',
	CONTACTS_PAGE = 'contacts-page',
	USER_COUNTS_DETAILS = 'user-counts-details-page',
	USER_COUNTS_LANDING = 'user-counts-landing-page',
	MOBILE_SECURITY_SETTINGS = 'mobile-security-settings-page',
	USER_ACCESS_SETTINGS = 'user-access-settings-page',
	APP_ACCESS_SETTINGS = 'app-access-settings-page',
	APP_CONTAINER_PAGE = 'app-container-page',
	DISCOVERED_PRODUCTS = 'discovered-products-page',
	SHADOW_IT_APPS = 'shadow-it-apps-page',
	SECURE_TUNNELS_PAGE = 'secure-tunnels-page',
	EMAILS_PAGE = 'emails-page',
	EMAIL_CONTENT_PAGE = 'email-content-page',
	BILLING_PREVIEW_PAGE = 'billing-preview-page',
	MOBILE_SECURITY_PAGE = 'mobile-security-page',
	USER_TIER_PAGE = 'user-tier-page',
	BRIE_DASHBOARD_PAGE = 'brie-dashboard-page',
	BRIE_POLICY_DETAILS_PAGE = 'brie-policy-details-page',
	BRIE_CREATE_POLICY_PAGE = 'brie-create-policy-page',
	BRIE_RESTORE_BACKUP_PAGE = 'brie-restore-backup-page',
	PRODUCT_REQUESTS_SETTING_PAGE = 'product-requests-setting-page',
	ATLASSIAN_INTELLIGENCE_PAGE = 'atlassian-intelligence-page',
	AI_ENABLED_APPS_PAGE = 'ai-enabled-apps-page',
	ROVO_ACCESS_PAGE = 'rovo-access-page',
	ROVO_OVERVIEW_PAGE = 'rovo-overview-page',
	ROVO_SETTINGS_PAGE = 'rovo-settings-page',
	ROVO_MCP_SERVER_PAGE = 'rovo-mcp-server-page',
	ROVO_A2A_PAGE = 'rovo-a2a-page',
	TWG_CLI_SETTINGS_PAGE = 'twg-cli-settings-page',
	TWG_CLI_SETTINGS_PAGE_LEGACY = 'twg-cli-settings-page-legacy',
	CODE_CONTEXT_PAGE = 'code-context-page',
	TEAMWORK_GRAPH_PAGE = 'teamwork-graph-page',
	TEAMWORK_GRAPH_PILLAR_PAGE = 'teamwork-graph-pillar-page',
	ROVO_CONNECTORS_PAGE = 'rovo-connectors-page',
	ROVO_CONNECTORS_PAGE_APPS_CHILD = 'rovo-connectors-page-apps-child',
	ROVO_INSIGHTS_NAV_PAGE = 'rovo-insights-nav-page',
	TOWNSQUARE_PAGE = 'townsquare-page',
	COMPLIANCE_MANAGE_PRODUCT_PAGE = 'compliance-manage-product-page',
	PRODUCT_REQUESTS_PAGE = 'product-requests-page',
	API_KEYS_PAGE = 'api-keys-page',
	MCP_SETTINGS_PAGE = 'mcp-settings-page',
	CUSTOM_DOMAINS_DETAILS_PAGE = 'custom-domains-details-page',
	SECURITY_CHECKLIST_PAGE = 'security-checklist-page',
	UNIFIED_POLICY_PAGE = 'unified-policy-page',
	UNIFIED_POLICY_DETAILS_PAGE = 'unified-policy-details-page',
	UGC_LANDING_PAGE_V2 = 'ugc-landing-page-v2',
	RELEASE_TRACKS_PAGE = 'release-tracks-page',
	EXPERIMENT_CONTROLS_PAGE = 'experiment-controls-page',
	IDENTITY_PROVIDERS_PAGE = 'identity-providers-page',
	DATA_RESIDENCY_PAGE = 'data-residency-page',
	DATA_RESIDENCY_SETTINGS_PAGE = 'data-residency-settings-page',
	ENCRYPTION_PAGE = 'encryption-page',
	LINKS_MIGRATION_PAGE = 'links-migration-page',
	USER_MERGE_HOME_PAGE = 'user-merge-home-page',
	USER_MERGE_START_PAGE = 'user-merge-start-page',
	LINKS_MIGRATION_AUDIT_LOG_PAGE = 'links-migration-audit-log-page',
	C2C_MIGRATION_DASHBOARD_PAGE = 'cloud-to-cloud-migration-dashboard-page',
	MIGRATION_DASHBOARD_PAGE = 'migration-dashboard-page',
	MIGRATION_PLAN_SCOPE_DETAILS = 'migration-plan-scope-details',
	PRODUCT_URLS_PAGE = 'product-urls-page',
	INSIGHTS_PAGE = 'insights-page',
	ANALYTICS_PAGE = 'analytics-page',
	ROVO_INSIGHTS_PAGE = 'rovo-insights-page',
	ROVO_CHAT_PROTECTION_PAGE = 'rovo-chat-protection-page',
	CONNECTOR_PROTECTION_PAGE = 'connector-protection-page',
	PLATFORM_USAGE_LANDING_PAGE = 'platform-usage-landing-page',
	PLATFORM_USAGE_DETAILS_PAGE = 'platform-usage-details-page',
	// TODO: EMER-351: Remove this route when we can deprecate meteringBucketId logic
	PLATFORM_USAGE_DETAILS_LEGACY_PAGE_WITH_METERING_BUCKET_ID = 'platform-usage-details-legacy-page-with-metering-bucket-id',
	IP_ALLOWLIST_PAGE = 'ip-allowlist-page',
	IP_ALLOWLIST_POLICY_DETAILS_PAGE = 'ip-allowlist-policy-details-page',
	TENANT_ACCESS_RESTRICTIONS_PAGE = 'tenant-access-restrictions-page',
	TENANT_ACCESS_RESTRICTIONS_POLICY_DETAILS_PAGE = 'tenant-access-restrictions-policy-details-page',
	CONDITIONAL_ACCESS_POLICIES_PAGE = 'conditional-access-policies-page',
	CONDITIONAL_ACCESS_POLICY_DETAILS_PAGE = 'conditional-access-policy-details-page',
	IDENTITY_PROVIDERS_DETAILS_PAGE = 'identity-providers-details-page',
	SANDBOX_PAGE = 'sandbox-page',
	SANDBOXES_PAGE = 'sandboxes-page',
	SANDBOX_CREATE_DEPLOYMENT_PAGE = 'sandbox-create-deployment-page',
	SANDBOXES_CREATE_DEPLOYMENT_PAGE = 'sandboxes-create-deployment-page',
	SANDBOXES_DEPLOYMENT_PAGE = 'sandboxes-deployment-page',
	SANDBOX_DEPLOYMENT_PAGE = 'sandbox-deployment-page',
	SANDBOXES_DEPLOYMENT_REPORT_PAGE = 'sandboxes-deployment-report-page',
	SANDBOX_DEPLOYMENT_REPORT_PAGE = 'sandbox-deployment-report-page',
	SANDBOX_DETAILS_PAGE = 'sandbox-details-page',
	SANDBOXES_DETAILS_PAGE = 'sandboxes-details-page',
	SANDBOX_UNIT_DETAILS_PAGE = 'sandbox-unit-details-page',
	AUTH_POLICIES_DETAILS_PAGE = 'authentication-policies-details-page',
	AUTH_POLICIES_PAGE = 'auth-policies-page',
	EXTERNAL_USER_SECURITY_PAGE_POLICY = 'external-user-security-page-policy',
	LOGIN_CUSTOMIZATION_PAGE = 'login-customisation-page',
	AUTH_POLICIES_AUTOMATION_PAGE = 'auth-policies-automation-page',
	GLOBAL_AUTOMATION_PAGE = 'global-automations-page',
	EXTERNAL_USER_SECURITY_PAGE = 'external-user-security-page',
	PRODUCT_DETAILS_PAGE = 'product-details-page',
	DATA_RESIDENCY_APP_DETAILS_PAGE = 'data-residency-app-details-page',
	ENCRYPTION_POLICY_DETAILS = 'encryption-policy-details-page',
	C2C_MIGRATION_DETAILS_PAGE = 'cloud-to-cloud-migration-details-page',
	C2C_MIGRATION_CREATE_PAGE = 'cloud-to-cloud-migration-create-page',
	C2D_MIGRATION_CREATE_PAGE = 'c2d-migration-create-page',
	MIGRATION_CONTROL_CENTER_PAGE = 'migration-control-center-page',
	AVIATOR_ROUTER = 'aviator-router',
	PRODUCT_UPDATES = 'product-updates-routes',
	ENVIRONMENTS = 'environments-page',
	ENVIRONMENT_DETAILS_PAGE = 'environment-details-page',
	PIPELINES = 'pipelines-page',
	FREEZE_WINDOWS = 'freeze-windows-page',
	GSUITE_SETTINGS = 'g-suite-settings',
	GSUITE_SETUP = 'g-suite-setup',
	EXTERNAL_USERS_POLICY_USERS = 'external-users-policy-users',
	EXTERNAL_USERS_POLICY_ID = 'external-users-policy-id',
	EXTERNAL_USER_DEFAULT_POLICY = 'external-users-default-policy',
	EXTERNAL_USER_POLICY = 'external-users-policy',
	EXTERNAL_USER_DEFAULT = 'external-users-default',
	PRODUCT_UPDATES_CHANGELOG_DETAILS_PAGE = 'product-updates-changelog-details-page',
	PRODUCT_UPDATES_LIST_VIEW_PAGE = 'product-updates-list-view-page',
	IDENTITY_PROVIDERS_SAML_PAGE = 'identity-providers-saml-page',
	IDENTITY_PROVIDERS_SCIM_PAGE = 'identity-providers-scim-page',
	IDENTITY_PROVIDERS_GSUITE_PAGE = 'identity-providers-g-suite-page',
	IDENTITY_PROVIDERS_OSYNC_PAGE = 'identity-providers-osync-page',
	IDENTITY_PROVIDERS_GROUPS_PAGE = 'identity-providers-groups-page',
	IDENTITY_PROVIDERS_DOMAINS_PAGE = 'identity-providers-linked-domains-page',
	IDENTITY_PROVIDERS_AUTH_DETAILS_PAGE = 'identity-providers-authentication-policies-details-page',
	IDENTITY_PROVIDERS_AUTH_POLICIES_PAGE = 'identity-providers-authentication-policies-page',
	IDENTITY_PROVIDERS_AUDIT_LOG_PAGE = 'identity-providers-audit-log-page',
	JSM_IDENTITY_PROVIDERS_SAML_PAGE = 'jsm-identity-providers-saml-page',
	JSM_IDENTITY_PROVIDERS_SAML_DETAILS_PAGE = 'jsm-identity-providers-details-page',
	JSM_SCIM_PAGE = 'jsm-identity-providers-scim-page',
	JSM_IDP_TROUBLESHOOTING_LOGS = 'jsm-identity-providers-troubleshooting-logs-page',
	JSM_PAGE = 'jsm-page',
	ACCESS_REQUESTS = 'access-requests-page',
	USER_CONNECTED_APPS = 'user-connected-apps-page',
	USER_CONNECTED_APPS_TAB = 'user-connected-apps-page-tab',
	USER_CONNECTED_APPS_DETAILS = 'user-connected-apps-details-page',
	USER_CONNECTED_APPS_STUDIO_APP_REVIEW = 'user-connected-apps-studio-app-review-page',
	USER_CONNECTED_APPS_PRODUCT_DETAILS = 'user-connected-apps-product-details',
	USER_CONNECTED_APPS_PRODUCT_DETAILS_TAB = 'user-connected-apps-product-details-tab',
	USER_CONNECTED_APPS_MCP_SERVER_PAGE = 'user-connected-apps-mcp-server-page',
	USER_CONNECTED_APPS_OAUTH = 'user-connected-apps-oauth',
	USER_CONNECTED_OAUTH_TAB = 'user-connected-apps-oauth-tab',
	SETUP_PAGE = 'setup-page',
	BILLING_PAGES = 'billing-pages',
	AVIATOR_ASSESSMENT = 'aviator-assessment-report-page',
	FOOTPRINT_INSIGHTS = 'footprint-insights-page',
	FOOTPRINT_INSIGHTS_CLOUD_READINESS = 'product-cloud-readiness-page',
	FOOTPRINT_INSIGHTS_INSTANCE_HEALTH = 'footprint-insights-instance-health-page',
	FOOTPRINT_INSIGHTS_OPTIMIZATION = 'product-optimization-page',
	FOOTPRINT_INSIGHTS_PERFORMANCE = 'product-performance-page',
	FOOTPRINT_INSIGHTS_SECURITY = 'product-security-page',
	FOOTPRINT_INSIGHTS_MARKETPLACE_APPS = 'product-marketplace-apps-page',
	AGENTS_OVERVIEW_PAGE = 'agents-overview-page',
	AGENTS_OVERVIEW_NAV_PAGE = 'agents-overview-nav-page',
	AGENT_DETAILS_PAGE = 'agent-details-page',
	AGENTS_EXPORT_DOWNLOAD_PAGE = 'agents-export-download-page',
	// Portfolio Insights Navigation V2 routes
	CLOUD_READINESS_PAGE = 'cloud-readiness-page',
	CLOUD_READINESS_DETAIL = 'cloud-readiness-details-page',
	CLOUD_READINESS_DETAIL_OVERVIEW = 'overview-page',
	CLOUD_READINESS_DETAIL_DATA_SHAPE = 'data-shape-page',
	CLOUD_READINESS_DETAIL_MARKETPLACE_APPS = 'marketplace-apps-page',
	CLOUD_READINESS_DETAIL_CUSTOM_APPS = 'custom-apps-page',
	CLOUD_READINESS_DETAIL_CUSTOMIZATIONS = 'customizations-page',
	CLOUD_READINESS_CUSTOMIZATION_DETAILS = 'customization-details-page',
	CUSTOMIZATIONS_PAGE = 'customizations-listing-page',
	INSTANCE_HEALTH_PAGE = 'instance-health-page',
	INSTANCE_HEALTH_DETAIL = 'instance-health-detail-page',
	INSTANCE_HEALTH_DETAIL_OPTIMIZATION = 'optimization-page',
	INSTANCE_HEALTH_DETAIL_PERFORMANCE = 'performance-page',
	INSTANCE_HEALTH_DETAIL_SECURITY = 'security-page',
	WORKFLOW_DISCOVERY_PAGE = 'workflow-discovery-top-level-page',
	WORKFLOW_DISCOVERY_DETAILS_PAGE = 'workflow-discovery-details-page',
	DETECTED_INSTANCES_PAGE = 'detected-instances-page',
	HIDDEN_INSTANCES_PAGE = 'hidden-instances-page',
	AVIATOR_MARKETPLACE_APPS = 'aviator-marketplace-apps-page',
	PERFORMANCE_MONITORING_PAGE = 'performance-monitoring-page',
	USER_SETUP_DETAILS_PAGE = 'user-setup-details-page',
	AVIATOR_SERVICE_HEALTH_DASHBOARD = 'aviator-service-health-dashboard',
	AVIATOR_SERVICE_HEALTH_DASHBOARD_CURRENT_STATUS = 'aviator-service-health-dashboard-current-status',
	AVIATOR_SERVICE_HEALTH_DASHBOARD_INCIDENT_DETAILS = 'aviator-service-health-dashboard-incident-details',
	AVIATOR_SERVICE_HEALTH_DASHBOARD_INCIDENT_HISTORY = 'aviator-service-health-dashboard-incident-history',
	AVIATOR_SERVICE_HEALTH_DASHBOARD_APP_DETAILS = 'aviator-service-health-dashboard-app-details',
	AVIATOR_SERVICE_HEALTH_DASHBOARD_MAINTENANCE_DETAILS = 'aviator-service-health-dashboard-maintenance-details',
	AVIATOR_SERVICE_HEALTH_DASHBOARD_NOTIFICATION_SETTINGS = 'aviator-service-health-dashboard-notification-settings',
	STATUS_HUB_PAGE = 'status-hub-page',
	DISASTER_RECOVERY = 'disaster-recovery',
	DISCOVERY_PAGE = 'discovery-page',
	DISCOVERY_PRODUCTS_PAGE = 'products-page',
	DISCOVERY_DETECTED_INSTANCES_PAGE = 'discovery-detected-instances-page',
	UPDATE_PAYMENT_METHOD = 'update-payment-method-page',
	ADD_PAYMENT_DETAILS = 'add-payment-details-page',
	MONTHLY_TO_ANNUAL = 'monthly-to-annual-page',
	MIGRATION_DATA_SCOPE = 'migration-data-scope',
	MIGRATION_SXP_CREATE_MIGRATION = 'migration-sxp-create-migration',
	MIGRATION_DC2C_CONNECT_PAGE = 'migration-dc2c-connect-page',
	MIGRATION_DC2C_DASHBOARD_PAGE = 'migration-dc2c-dashboard-page',
	MIGRATION_DC2C_CREATE_MIGRATION = 'migration-dc2c-create-migration',
	MIGRATION_DC2C_MIGRATION_DETAILS = 'migration-dc2c-migration-details-page',
	MIGRATION_DC2C_MIGRATION_PREFLIGHTS_PAGE = 'migration-dc2c-migration-preflights-page',
	MIGRATION_DC2C_DELTA_MIGRATIONS_HOME_PAGE = 'migration-dc2c-delta-migrations-home-page',
	MIGRATION_DC2C_CONNECT_TO_SOURCE = 'migration-dc2c-connect-to-source',
	MIGRATION_PERMISSION_PAGE = 'migration-permission-error-page',
	CHANGE_EDITION_ENTITLEMENT = 'change-edition-entitlement',
	CHOOSE_ANNUAL_BILLING_CYCLE = 'choose-annual-billing-cycle',
	TEAM_SITE_ASSIGNMENT_PAGE = 'team-site-assignment-page',

	// org billing routes
	ORG_BILLING_OVERVIEW_PAGE = 'org-billing-overview-page',
	ORG_BILLING_PAYMENT_DETAILS_PAGE = 'org-billing-payment-details-page',
	ORG_BILLING_HISTORY_PAGE = 'org-billing-history-page',
	ORG_BILLING_ESTIMATE_PAGE = 'org-billing-estimate-page',
	ORG_BILLING_MANAGE_SUBSCRIPTIONS_PAGE = 'org-billing-manage-subscriptions-page',

	// site routes
	SITE_USER_EXPORT_DOWNLOAD_PAGE = 'site-user-export-download-page',
	SITE_AGENTS_EXPORT_DOWNLOAD_PAGE = 'site-agents-export-download-page',
	SITE_ACCESS_REQUESTS_PAGE = 'site-access-requests-page',
	SITE_ACCESS_CONFIGURATION_PAGE = 'access-configuration-page',
	SITE_JSM_PAGE = 'site-jsm-page',
	SITE_JSM_IDP_PAGE = 'jsm-idp-page',
	SITE_USER_CONNECTED_APPS_PAGE = 'site-user-connected-apps-page',
	SITE_USER_CONNECTED_APPS_SUBPAGE = 'site-user-connected-apps-subpage',
	SITE_USER_CONNECTED_APPS_DETAILS_PAGE = 'site-user-connected-apps-details-page',
	SITE_ACCESS_PAGE = 'access-page',

	// billing site routes
	SITE_BILLING_OVERVIEW_PAGE = 'site-billing-overview-page',
	SITE_BILLING_PAYMENT_DETAILS_PAGE = 'site-billing-payment-details-page',
	SITE_BILLING_HISTORY_PAGE = 'site-billing-history-page',
	SITE_BILLING_ESTIMATE_PAGE = 'site-billing-estimate-page',
	SITE_BILLING_MANAGE_SUBSCRIPTIONS_PAGE = 'site-billing-manage-subscriptions-page',
	SITE_BILLING_ADD_APPLICATION_PAGE = 'site-billing-add-application-page',

	// SITE_BILLING_NEW_PRODUCTS_PAGE = 'site-billing-new-products-page',
	// SITE_BILLING_UPFLOW_PAYMENTS_PAGE = 'site-billing-upflow-payments-page',

	// for ufo
	ACCESS_SITE = 'site-access-page',
	SITE_GSUITE_PAGE = 'gsuite-page',
	SITE_EMOJI_PAGE = 'emoji-page',
	SITE_PHONE_NUMBERS_PAGE = 'phone-numbers-page',
	SITE_PHONE_NUMBERS_TAB_PAGE = 'phone-numbers-tab-page',
	SITE_STORAGE_PAGE = 'storage-page',
	SITE_SETUP_PAGE = 'site-setup-page',
	SITE_BILLING_PAGE = 'site-billing-pages',
	SITE_BILLING_PREVIEW_PAGE = 'site-billing-preview-page',
	// top routes
	TOP_ROUTE_DASHBOARD = 'dashboard',
	TOP_ROUTE_SHADOW_IT_REQUEST_GATE = 'shadow-it-request-gate',
	TOP_ROUTE_ORG_PICKER = 'org-picker',
	TOP_ROUTE_ORG_PICKER_ATLASSIAN_ACCESS = 'org-picker-atlassian-access',
	TOP_ROUTE_ORG_PICKER_ATLASSIAN_GUARD = 'org-picker-atlassian-guard',
	TOP_ROUTE_ORG_PICKER_ATLASSIAN_GUARD_PREMIUM = 'org-picker-atlassian-guard-premium',
	TOP_ROUTE_ROVO = 'rovo',
}

export enum TagIds {
	SHD_BETA_LOZENGE = 'shd-beta-lozenge',
}
